import {observable,action} from 'mobx'
import {getVal,setVal,deleteVal} from '../../utils/server'

//做添加规则步骤条的缓存
class ThresholdRuleStore{
  @observable addThresholdRuleInfo = getVal("addThresholdRule",{
    "alertName":"",
    "metricName":"",
    "period":"1m",
    "periodNum":1,
    "aggregateFunction":"min_over_time",
    "arithmeticOperator":">",
    "threshold":0,
    "alertDescription":"",
    "alertSummary":"",
    "alertStatus":"一般",
    "alertWaitTime":"15s",
    "sendAlert":1
  })
  @observable addSendRuleInfo = getVal("addSendRule",{
    "alertName":"",
    "repeatSendingTime":"10m",
    "sameGroupTime":"1m",
    "userGroup":""
  })
  @observable editThresholdRuleInfo = getVal("editThresholdRule","")
  @observable checkThresholdRuleInfo = getVal("checkThresholdRule","")
  @observable thresholdRules = getVal("thresholdRules",[])
  @observable from = getVal("from","/home/alerts/rules")

  @action setAddThresholdRuleInfo(info){
    this.addThresholdRuleInfo = info
    setVal("addThresholdRule",this.addThresholdRuleInfo)
  }
  @action setAddSendRuleInfo(info){
    this.addSendRuleInfo = info
    setVal("addSendRule",this.addSendRuleInfo)
  }
  @action setEditThresholdRuleInfo(info){
    this.editThresholdRuleInfo = info
    setVal("editThresholdRule",this.editThresholdRuleInfo)
  }
  @action setCheckThresholdRuleInfo(info){
    this.checkThresholdRuleInfo = info
    setVal("checkThresholdRule",this.checkThresholdRuleInfo)
  }
  @action setThresholdRules(rules){
    this.thresholdRules = rules
    setVal("thresholdRules",this.thresholdRules)
  }
  @action setFrom(from){
    this.from = from
    setVal("from",this.from)
  }

  @action deleteInfo(){
    deleteVal("addThresholdRule")
    deleteVal("addSendRule")
  }
  @action deleteEditInfo(){
    deleteVal("editThresholdRule")
  }
}

export default new ThresholdRuleStore()


// WEBPACK FOOTER //
// ./src/routes/AlertRules/store.js